import EventTracker from "/js/components/EventTracker.js";

const ItemManager = {
  types: [],
  items: {},
  initilised: false,
  data: [],
  store: {},
  events: [],
  global: {},
  timeouts: {},
  intervals: {},
  localData: null,

  // create the item types that are required based on the body classes
  init() {
    let me = this;
    if (me.initilised) return;

    EventTracker.init();

    for (let i = 0; i < me.types.length; i++) {
      if ($('#g-item-manager').hasClass(me.types[i].cls)) {
        me.items[me.types[i].cls] = me.types[i].obj;
        me.items[me.types[i].cls].init();
      }
    }
    $('#g-item-manager').addClass('g-load-complete');
    
    EventTracker.saveData(undefined,
      EventTracker.ACTION_START,
      $('#task').data('itemid')
    );

    me.initilised = true;
  },

  destroy() {
    this.types = [];
    this.items = {};
    this.data = [];
    this.store = {};
    this.events = [];
    this.global = {};
    this.localData = null;
    this.initilised = false;
    
    Object.entries(this.timeouts).forEach(([id])=>clearInterval(id));
    Object.entries(this.intervals).forEach(([id])=>clearInterval(id));
    this.timeouts = {};
    this.intervals = {};

    // elements blocky creates that sit outside the units, not sure how to properly
    // destroy blockly
    $('.blocklyWidgetDiv, .blocklyDropDownContent').html('');
    $('.blocklyDropDownDiv').css({'opacity':0});
  },

  register(...types) {
    this.types = [...this.types, ...types];
  },

  getId(el) {
    return el ? ($(el).data("id") ? $(el).data("id") : el.id) : '';
  },

  getState(format='string', fullResponse=true) {

    // Loops over all widgets and calls their save method
    for (var key in this.items) {
      if (typeof (this.items[key].saveResults) == 'function') {
        this.items[key].saveResults(fullResponse);
      }
    }

    let state = {
      id: $('#task').data('itemid') ? $('#task').data('itemid') : null,
      response: this.data,
      common: this.store,
      event: this.events
    };

    // change here to return in a different format
    return format == 'json' ? state : JSON.stringify(state);
  },

  setState(serverData) {
    let me = this;
    let data = {};

    if ( typeof serverData === 'string' ) {
      // change here to parse from a different format
      try {
        data = JSON.parse(serverData);
      } catch (e) {
        // do something
      }
    } else {
      data = serverData;
    }
    
    me.data = [];
    me.store = {};
    me.global = {};

    if (data) {
      if (data['global']) {
        me.global = data['global'];
      }
      if (data["response"]) {
        if ( data["response"]["response"] ) {
          me.data = data["response"]["response"];
        } else {
        me.data = data["response"];
        }
      }
      if (data['common']) {
        me.store = data['common'];
      }
      if (data['event'] && data['event'].length > 0) {
        me.events = data['event'];
      }
    }

    //if we are loading the item for the first time we need to initilise the components before applying the state
    if (!me.initilised) {
      me.init();
    }

    for (var key in me.items) {
      if (typeof (me.items[key].loadResults) === 'function') {
        me.items[key].loadResults(false);
      }
    }
  },

  getCommonValue(key) {
    if (this.global['userid'] != null ) {
      return localStorage.getItem(this.global['userid'] +'.'+ key);
    } else {
      return this.store[key];
    }
  },

  setCommonValue(key, value) {
    if (this.global['userid'] != null ) { 
      // if not set before set first creation date in case its useful one day
      if (localStorage.getItem(this.global['userid'] +'.created') == null) {
        localStorage.setItem(this.global['userid'] +'.created', Date.now());
      }
      localStorage.setItem(this.global['userid'] +'.'+ key, value);
    } else {
      this.store[key] = value;
    }
  },

  setValue(element, value) {
    let parts = element.split(".");

    if (this.data[parts[2]] == null) {
      this.data[parts[2]] = {};
    }
    this.data[parts[2]][parts[3]] = value;
  },

  getInteractionPos(id) {
    if (id == null) {
      alert('ID should not be null');
    }
    let idx = this.data.findIndex(e => e.id == id);
    return idx == -1 ? this.data.length : idx;
  },

  getInteraction(id) {
    let i = this.data.find(e => e.id == id);
    return i == null ? i : i.learner_response;
  },

  setEventData(value) {
    if (!Array.isArray(value)) {
      value = [value];
    }
    this.events = this.events.concat(value);
  },  

  saferSetTimeout(cb, int) {
    let id = setTimeout(_=>{
      delete this.timeouts[id];
      cb();
    }, int);
    this.timeouts[id]=true;
    return id;
  },

  saferClearTimeout(id) {
    clearTimeout(id);
    delete this.timeouts[id];
  },

  saferClearInterval(id) {
    clearInterval(id);
    delete this.intervals[id];
  },

  saferSetInterval(cb, int) {
    let id = setInterval(cb, int);
    this.intervals[id]=true;
    return id;
  }
};
window.ItemManager = ItemManager;
export default ItemManager;
